'use strict';

exports.__esModule = true;

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Symbol key that carries API call info interpreted by this Redux middleware.
 *
 * @constant {symbol}
 * @access public
 * @default
 */
var CALL_API = (0, _symbol2.default)('Call API');

exports.default = CALL_API;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@aftonbladet/redux-api-middleware/lib/CALL_API.js
 ** module id = 167
 ** module chunks = 1
 **/